module.exports = __webpack_public_path__ + "static/media/aimee_challies.85046e37.jpg";